var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fileType === "image"
    ? _c("div", [
        _c("div", { staticClass: "file-field__label text_small" }, [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container container_40 image-input",
            class: { disabled: _vm.disableField }
          },
          [
            _c("input", {
              staticClass: "download-input",
              class: { "file-loaded": _vm.fileUrl },
              attrs: { type: "file", accept: "image/*" },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "image-input__inner" }, [
              _c(
                "div",
                { staticClass: "image-input__icon" },
                [
                  _c("md-icon", {
                    attrs: { "md-src": "/static/img/drag_drop_icon.svg" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "image-input__text" },
                [
                  _vm.fieldType === "tokenCreation"
                    ? _c("div", {
                        staticClass: "title",
                        domProps: {
                          innerHTML: _vm._s(_vm.i18n.lbl_chose_image_token())
                        }
                      })
                    : _vm.fieldType === "campaignCreation"
                    ? _c("div", {
                        staticClass: "title",
                        domProps: {
                          innerHTML: _vm._s(_vm.i18n.lbl_chose_image_campaign())
                        }
                      })
                    : _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.i18n.lbl_choose_image()))
                      ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.fieldType === "campaignCreation"
                      ? _vm.notes_campaign
                      : _vm.notes,
                    function(note, key) {
                      return _c(
                        "p",
                        {
                          key: key,
                          staticClass: "image-input__note text_x_small"
                        },
                        [_vm._v(_vm._s(note))]
                      )
                    }
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm.fileUrl
                ? _c("div", { staticClass: "image-input__image-preview" }, [
                    _c("img", { attrs: { src: _vm.fileUrl } })
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    : _c("div", { staticClass: "file-field__outer" }, [
        _c("div", { staticClass: "file-field" }, [
          _c(
            "label",
            { staticClass: "file-field__uploader", attrs: { for: _vm.id } },
            [
              _vm.id !== "documents-tab__file-field"
                ? _c(
                    "md-icon",
                    { staticClass: "file-field__icon md-icon-size-075x" },
                    [_vm._v("insert_drive_file")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._v("\n        " + _vm._s(_vm.acceptLabel) + "\n      ")
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            staticClass: "file-field__input",
            attrs: {
              type: "file",
              id: _vm.id,
              name: _vm.name,
              required: _vm.required,
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              accept: _vm.accept
            },
            on: { change: _vm.onChange }
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "file-field__file-name" }, [
          _vm.value && _vm.value.file
            ? _c(
                "button",
                {
                  staticClass: "link-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.viewNew }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.value.name))]),
                  _vm._v(" "),
                  _c(
                    "md-icon",
                    { staticClass: "file-field__link-icon md-icon-size-065x" },
                    [_vm._v("open_in_new")]
                  )
                ],
                1
              )
            : _vm.value && _vm.fileUrl
            ? _c(
                "a",
                { attrs: { href: _vm.fileUrl, target: "_blank" } },
                [
                  _c("span", [_vm._v(_vm._s(_vm.value.name))]),
                  _vm._v(" "),
                  _c(
                    "md-icon",
                    { staticClass: "file-field__link-icon md-icon-size-065x" },
                    [_vm._v("open_in_new")]
                  )
                ],
                1
              )
            : _c("span", [_vm._v(_vm._s(_vm.i18n.fi_no_file_chosen()))])
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44f8cf8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f8cf8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/FileField.vue
// module id = Oq2/
// module chunks = 1